import React from 'react'
import { View, ScrollView, Text } from 'react-native'
import { Loading } from './src/components/loading'
import { Router } from './src/router'
import { useFonts, Roboto_400Regular } from '@expo-google-fonts/roboto'


const App = () => {
  let [fontsLoaded] = useFonts({
    Roboto_400Regular,
  });

  return (
    <AppRouter style={{fontFamily: 'Roboto_400Regulsr'}} />
  )
}

export default App

const AppRouter = () => {
  return <React.Suspense fallback={<Loading />}>{<Router />}</React.Suspense>
}
